// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"169":"da12b3ff","240":"abcc1154","489":"4f746a29","773":"1488dc03","982":"abcc1154"}[chunkId] + ".chunk.css";
};